<template>
  <div>
    <a
      class="nav-link"
      @click="openModal()"
    >{{ __('Integrações') }}</a>
    <BModal
      id="modal-form-integration"
      modal-class="modal-no-header-no-footer modal-width-850"
      size="lg"
      ref="modal-form-integration"
      hide-header="hide-header"
      hide-footer="hide-footer"
    >
      <template slot="default">
        <button
          class="close"
          type="button"
          aria-label="Close"
          @click="$refs['modal-form-integration'].hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title mb-3">
          {{ __('Integração Iframe') }}<a
            class="copy-link ml-2"
            id="copy-iframe"
            href="#"
            title="Copiar"
            ref="copy-iframe"
            data-clipboard-target="#integration-iframe-code"
          >{{ __('Copiar código') }}</a>
        </h4>
        <div class="px-20px">
          <div class="form-group">
            <input
              class="form-control"
              id="integration-iframe-code"
              type="text"
              :value="integration.iframe"
              readonly="readonly"
              v-if="integration.iframe"
            ><i
              class="fa fa-circle-o-notch fa-spin"
              v-else
            />
          </div>
          <div class="form-group">
            <div class="alert alert-danger">
              {{ __('Lembre-se: Essa integração não aceita redirecionamentos.') }}
            </div>
          </div>
        </div>
        <h4 class="modal-title pt-2 mb-3">
          {{ __('Integração Javascript') }}<a
            class="copy-link ml-2"
            id="copy-js"
            href="#"
            title="Copiar"
            ref="copy-js"
            data-clipboard-target="#integration-js-code"
          >{{ __('Copiar código') }}</a>
        </h4>
        <div class="px-20px">
          <div class="form-group">
            <textarea
              class="form-control"
              id="integration-js-code"
              rows="12"
              :value="integration.javascript"
              readonly="readonly"
              v-if="integration.javascript"
            /><i
              class="fa fa-circle-o-notch fa-spin"
              v-else
            />
          </div>
        </div>
      </template>
    </BModal>
  </div>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  props: {
    formhashid: {
      type: String,
      required: true,
    },
  },

  data () {
    return {
      integration: {
        iframe: null,
        javascript: null,
      },
      modules: [],
      types: false,
      error: null,
      saving: false,
      clip: false,
    };
  },

  mounted () {
    this.loadIntegrationIFrame();
    this.loadIntegrationJS();
  },

  methods: {
    openModal () {
      this.$refs['modal-form-integration'].show();

      setTimeout(() => {
        document.querySelector('#form.name').focus();
      }, 500);

      if (this.clip) {
        this.clip.destroy();
      }

      this.$nextTick(() => {
        this.clip = (new ClipboardJS(this.$refs['copy-iframe'])).on('success', () => {
          Alert.success(this.__('Link copiado!'));
        });
      });

      this.$nextTick(() => {
        this.clip = (new ClipboardJS(this.$refs['copy-js'])).on('success', () => {
          Alert.success(this.__('Link copiado!'));
        });
      });
    },

    loadIntegrationIFrame () {
      this.$http.get(`/form/integration/iframe?form=${this.formhashid}`)
        .then(({ data }) => {
          console.log(data);
          this.integration.iframe = data;
        })
        .catch((error) => {
          console.log('Não foi possivel encontrar o script de integração, erro: ');
          console.log(error);
        });
    },

    loadIntegrationJS () {
      this.$http.get(`/form/integration/javascript?form=${this.formhashid}`)
        .then(({ data }) => {
          this.integration.javascript = data;
        })
        .catch((error) => {
          console.log('Não foi possivel encontrar o script de integração, erro: ');
          console.log(error);
        });
    },
  },
};
</script>
